module.exports = __webpack_public_path__ + "static/media/screen-youtube-nodon.94066444.png";